import { RouteObject } from "react-router-dom";
import {
  ACCESS_CONTROL,
  ACCESS_CONTROL_ROLE_CREATE,
  ACCESS_CONTROL_ROLE_EDIT,
  ACCESS_CONTROL_RESOURCE_SET_CREATE,
  ACCESS_CONTROL_RESOURCE_SET_EDIT,
} from "constants/urls";

export default [
  {
    index: true,
    path: ACCESS_CONTROL,
    lazy: () => import("modules/access-control/pages/AccessControl"),
  },
  {
    path: ACCESS_CONTROL_ROLE_CREATE,
    lazy: () => import("modules/access-control/pages/RoleCreateUpdate"),
  },
  {
    path: ACCESS_CONTROL_ROLE_EDIT,
    lazy: () => import("modules/access-control/pages/RoleCreateUpdate"),
  },
  {
    path: ACCESS_CONTROL_RESOURCE_SET_CREATE,
    lazy: () => import("modules/access-control/pages/ResourceSetCreateUpdate"),
  },
  {
    path: ACCESS_CONTROL_RESOURCE_SET_EDIT,
    lazy: () => import("modules/access-control/pages/ResourceSetCreateUpdate"),
  },
] as RouteObject[];
